import { Configuration, TeamContext } from "../types/common";
import { getSiteByTeamCode } from "../utils";

export const useConfiguration = (asRef: boolean = false): Configuration => {
    const path = globalThis.location.pathname;
    const config = { ...globalThis.FCRC_PHP_DATA } as Configuration;

    if (path.includes('/3/') || path.includes('/m/')) {
        config.teamName = TeamContext.RODINA_3;
        config.seasonId = 19;
        config.tournamentId = 181;
        config.teamId = 724;
    } else if (path.includes('/2/')) {
        config.teamName = TeamContext.RODINA_2;
        config.seasonId = 18;
        config.tournamentId = 180;
        config.teamId = 135;
    } else if (path.includes('/rodina/')) {
        config.teamName = TeamContext.RODINA;
        config.seasonId = 18;
        config.tournamentId = 178;
        config.teamId = 3;
    } else if (path.includes('/y/') || path.includes('/youth/')) {
        config.teamName = TeamContext.RODINA_M;
        config.seasonId = 17;
        config.tournamentId = 385;
        config.teamId = 204;
    } else if (globalThis?.location?.hostname?.includes('academy')) {
        config.teamName = TeamContext.ACADEMY;
        config.seasonId = 17;
        config.tournamentId = 384;
        config.teamId = 3;

        if (!config.mainScreenConfig) {
            config.mainScreenConfig = {
                filters: [],
                table: {
                    topTeams: 3,
                    bottomTeams: 2,
                },
                matches: {
                    prevMatches: 2,
                    totalMatches: 6,
                }
            };
        }
        config.mainScreenConfig.filters = [{
            title: 'ЮФЛ-3',
            tournamentId: 382,
            seasonId: 17,
            teamId: 3,
        }, {
            title: 'ЮФЛ-2',
            tournamentId: 383,
            seasonId: 17,
            teamId: 3,
        }, {
            title: 'ЮФЛ-1',
            tournamentId: 384,
            seasonId: 17,
            teamId: 3,
        }]
    }

    config.site = getSiteByTeamCode(config.teamName);

    if (config.teamName === TeamContext.RODINA) {
        /*config.mainScreenConfig.calendarWidget = {
            seasonUuid: '37b869dc-4227-4aaa-9ee6-5f5293a4f3b6',
        }*/
    }

    globalThis.FCRC_PHP_DATA = config;

    if (asRef) {
        return globalThis.FCRC_PHP_DATA as Configuration;
    }

    return { ...globalThis.FCRC_PHP_DATA } as Configuration;
}

export const useTeamContext = () => {
    const config: Configuration = useConfiguration();
    return config?.teamName;
}
